/* ============================================================
   MEGA-MENUE · Bruecke zu Dawns Burger

   Dawns Kopfzeile bringt ihren eigenen Menue-Knopf mit. Statt ihn
   zu ersetzen - was eine Dawn-Datei veraendern wuerde und jedes
   Theme-Update blockiert - faengt dieses Skript nur seinen Klick
   ab und oeffnet stattdessen unser Menue.

   Vorteil: Der Knopf sitzt weiterhin genau dort, wo Dawn ihn
   platziert, in jeder Bildschirmgroesse. Wir muessen ihn nicht
   nachbauen und nicht ausrichten.
   ============================================================ */
(function () {
  'use strict';

  if (window.lieblingscapDrawerBridge) return;
  window.lieblingscapDrawerBridge = true;

  function unserDrawer() {
    return document.querySelector('[data-lc-drawer] [data-lc-details]');
  }

  function oeffne() {
    var details = unserDrawer();
    if (!details) return false;
    details.open = true;
    return true;
  }

  /* Dawns eigene Schublade darf sich nie oeffnen - sonst laegen zwei
     Menues uebereinander. */
  function haltDawnZu() {
    document.querySelectorAll('header-drawer details, .header__icon--menu').forEach(function (el) {
      var details = el.tagName === 'DETAILS' ? el : el.closest('details');
      if (details && details.open) details.open = false;
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var ziel = e.target.closest
        ? e.target.closest('.header__icon--menu, header-drawer summary')
        : null;
      if (!ziel) return;

      /* Nur abfangen, wenn unser Menue tatsaechlich da ist. Fehlt der
         Abschnitt, bleibt Dawns Schublade als Rueckfallebene. */
      if (!unserDrawer()) return;

      e.preventDefault();
      e.stopPropagation();
      haltDawnZu();
      oeffne();
    },
    true
  );

  /* Falls Dawns Schublade doch aufgeht - etwa per Tastatur - sofort
     wieder schliessen und unsere oeffnen. */
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details || details.tagName !== 'DETAILS' || !details.open) return;
    if (!details.closest('header-drawer')) return;
    if (!unserDrawer()) return;

    details.open = false;
    oeffne();
  }, true);
})();